import { render } from "./OTPAuth.vue?vue&type=template&id=4b4e42f2"
import script from "./OTPAuth.vue?vue&type=script&lang=js"
export * from "./OTPAuth.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\34\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__